/**
 * Trainer Modal Handler - Individual modals for each trainer
 */

document.addEventListener('DOMContentLoaded', function() {
    const triggers = document.querySelectorAll('.trainer-modal-trigger');

    triggers.forEach(trigger => {
        const trainerBox = trigger.closest('.trainer');
        const trainerId = trainerBox.dataset.trainerId;
        const modal = document.getElementById(`trainerModal-${trainerId}`);
        
        if (!modal) return;
        
        const modalOverlay = modal.querySelector('.trainer-modal__overlay');
        const modalClose = modal.querySelector('.trainer-modal__close');

        // Pomocnicza funkcja do płynnej podmiany obrazka
        function swapImage(imgEl, newSrc) {
            if (!imgEl || !newSrc || imgEl.src === newSrc) return;
            imgEl.classList.add('is-fading');
            // Po krótkim czasie podmień src i pokaż ponownie
            setTimeout(() => {
                imgEl.src = newSrc;
                imgEl.onload = () => {
                    imgEl.classList.remove('is-fading');
                };
            }, 150);
        }

        // Helper: detect mobile
        function isMobile() {
            return window.innerWidth <= 768;
        }

        // Otwórz modal
        function openModal() {
            // Zamknij wszystkie inne otwarte modale
            const allModals = document.querySelectorAll('.trainer-modal.active');
            allModals.forEach(otherModal => {
                otherModal.classList.remove('active');
                // Przywróć obraz w odpowiadającym trenerze
                const otherId = otherModal.id?.split('trainerModal-')[1];
                if (otherId) {
                    const otherTrainer = document.querySelector(`.trainer[data-trainer-id="${otherId}"] img.trainer-image`);
                    if (otherTrainer) {
                        const defaultSrc = otherTrainer.getAttribute('data-default-src');
                        if (defaultSrc) {
                            // szybka podmiana bez animacji przy zamykaniu innego
                            otherTrainer.src = defaultSrc;
                            otherTrainer.classList.remove('is-fading');
                        }
                    }
                }
            });
            
            // Otwórz wybrany modal
            modal.classList.add('active');

            if (isMobile()) {
                // Na mobile przewiń do aktualnego modala (z kompensacją dla stałego headera)
                const header = document.querySelector('.header, .site-header, .c-header');
                let offset = 0;
                if (header) {
                    const style = window.getComputedStyle(header);
                    if (style.position === 'fixed') {
                        offset = header.offsetHeight || 0;
                    }
                }
                const rect = modal.getBoundingClientRect();
                const targetY = rect.top + window.pageYOffset - offset - 10; // mały margines
                try {
                    window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
                } catch (e) {
                    window.scrollTo(0, Math.max(0, targetY));
                }
                // Zablokuj scroll po krótkiej chwili, aby nie przerwać scrollowania
                setTimeout(() => {
                    document.body.classList.add('modal-open');
                }, 250);
            } else {
                document.body.classList.add('modal-open');
            }

            // Podmień zdjęcie trenera na alternatywne, jeśli jest
            const img = trainerBox.querySelector('img.trainer-image');
            if (img) {
                const altSrc = img.getAttribute('data-alt-src');
                if (altSrc) swapImage(img, altSrc);
            }
        }

        // Zamknij modal
        function closeModal() {
            modal.classList.remove('active');
            document.body.classList.remove('modal-open');

            // Przywróć domyślne zdjęcie po zamknięciu
            const img = trainerBox.querySelector('img.trainer-image');
            if (img) {
                const defaultSrc = img.getAttribute('data-default-src');
                if (defaultSrc) swapImage(img, defaultSrc);
            }
        }

        // Event listener dla przycisku
        trigger.addEventListener('click', openModal);

        // Zamknij modal przez overlay
        if (modalOverlay) {
            modalOverlay.addEventListener('click', closeModal);
        }

        // Zamknij modal przez przycisk X
        if (modalClose) {
            modalClose.addEventListener('click', closeModal);
        }

        // Zamknij modal przez ESC (tylko jeśli ten modal jest aktywny)
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                closeModal();
            }
        });
    });
});
